import { cn } from '../../lib/cn';

export interface ConfidenceDotProps {
  /** 0-100 extraction confidence score. */
  score: number | null | undefined;
  /** The dot appears only below this score. */
  threshold?: number;
  className?: string;
}

/**
 * The ONLY confidence encoding allowed in a table row: an exception dot, or
 * nothing. High-confidence rows show NOTHING — model internals never earn a
 * permanent column. The exact percentage lives in the row's detail panel.
 */
export default function ConfidenceDot({ score, threshold = 50, className }: ConfidenceDotProps) {
  if (score == null || score >= threshold) return null;
  const label = `Extraction confidence ${Math.round(score)}%`;
  return (
    <span
      title={label}
      role="img"
      aria-label={label}
      className={cn('inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-warn', className)}
    />
  );
}
